/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleMenuManagementState.js'
import mutations from './moduleMenuManagementMutations.js'
import actions from './moduleMenuManagementActions.js'
import getters from './moduleMenuManagementGetters.js'


export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

